import React from 'react'
import _ from 'lodash'
import { config } from 'config'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { Link } from 'react-router'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import profilePic from './profile-pic.jpg'
import styles from './PortfolioNextPrevLink.module.scss'

class PortfolioNextPrevLink extends React.Component {

  static propTypes () {
    return {
      data: React.PropTypes.object,
    }
  }

  render () {
    const data = this.props.data;

    return (
      <div className={styles.container}>
        {data.nextWork &&
          <Link to={data.nextWork.path} className={styles.nextLink}>NEXT →</Link>
        }

        {data.previousWork &&
          <Link to={data.previousWork.path} className={styles.prevLink}>← PREVIOUS</Link>
        }
      </div>
    )
  }
}

export default PortfolioNextPrevLink



/** WEBPACK FOOTER **
 ** ../components/PortfolioNextPrevLink.js
 **/